import React, {PropTypes} from "react";
import RecruiterForm from "../components/RecruiterForm";
import axios from "axios";


function convert(node) {
  node.offerDate = node.offerDate ? new Date(node.offerDate) : null;
  node.joiningDate = node.joiningDate ? new Date(node.joiningDate) : null;
  node.empDob = node.empDob ? new Date(node.empDob) : null;
  return node;
}

class RecruiterAddEdit extends React.Component {

  constructor() {
    super();
    this.state = {initialValues: {initialValues: null}};
    this.refreshForm = this.refreshForm.bind(this);

  }

  refreshForm() {
    axios.get(process.env.REQ_URL + "/onBoarding/getJoinerById?q=" + this.props.params.id, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      response.data.data = convert(response.data.data);
      if (response.data.data.name != null) {
        response.data.data.firstName = response.data.data.name.split(' ')[0];
        response.data.data.lastName = response.data.data.name.split(' ')[1];
      }
      this.setState({initialValues: {initialValues: response.data.data}});


    }).catch((error)=> {
      console.log(error);
    })
  }

  componentDidMount() {
    this.props.changeBanner("Onboarding - edit")
    axios.get(process.env.REQ_URL + "/onBoarding/getJoinerById?q=" + this.props.params.id, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      response.data.data = convert(response.data.data);
      if (response.data.data.name != null) {
        response.data.data.firstName = response.data.data.name.split(' ')[0];
        response.data.data.lastName = response.data.data.name.split(' ')[1];
      }
      this.setState({initialValues: {initialValues: response.data.data}});


    }).catch((error)=> {
      console.log(error);
    })
  }

  componentWillReceiveProps(props) {

  }

  render() {
    console.log(this.state.initialValues);

    return (
      <div>
        <RecruiterForm
          recruiter={this.props.recruiter}
          refreshForm={this.refreshForm}
          params={this.props.params}
          submitNew={this.props.submitNew}
          submitEdit={this.props.submitEdit}
          constants={this.props.constants}
          activeEmployees={this.props.activeEmployees}
          {...this.state.initialValues}/>
      </div>
    );
  }
}

RecruiterAddEdit.propTypes = {};

export default RecruiterAddEdit;





/** WEBPACK FOOTER **
 ** ./src/feature/onboarding/containers/RecruiterAddEdit.js
 **/